import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Ao mudar de página volta ao topo; com #âncora (data-anchor) desce até à secção visível (a do telemóvel ou a do desktop).
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (!hash) return undefined;
    let tries = 0;
    let raf;
    const seek = () => {
      const el = [...document.querySelectorAll(`[data-anchor="${hash.slice(1)}"]`)].find((e) => e.offsetParent !== null);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      else if (tries++ < 30) raf = requestAnimationFrame(seek);
    };
    raf = requestAnimationFrame(seek);
    return () => cancelAnimationFrame(raf);
  }, [pathname, hash]);
  return null;
};
